var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"static-icon-preview-background"},[_c('eicon',{attrs:{"kind":_vm.iconKind}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }